<template>
    <div class="hrm_menu_block btn-group flex-none dropstart hrm_table_menu">
        <slot name="menuBtn">
            <button v-if="props.icon" @click="showMenu = !showMenu" type="button"
                class=" btn btn-secondary h-6 w-6 theme-dropdown-btn bg-[#393E45]  " data-bs-toggle="dropdown"
                aria-expanded="false" data-dropdown-trigger="hover">
                <Icon :icon="props.icon" width="20" height="20" color="white" class="" />
            </button>
            <button v-else @click="showMenu = !showMenu" type="button"
                class=" hrm_custom_text_icon_button hrm_button_hover group relative bg-hrmThemeBgColor text-hrmThemeTextColor rounded-lg text-xs font-semibold h-[36px] w-9 flex items-center justify-center  "
                data-bs-toggle="dropdown" aria-expanded="false" data-dropdown-trigger="hover">
                <Icon icon="gridicons:menus" width="20" height="20" color="white" />
            </button>
        </slot>
        <div class="dropdown-menu theme-dropdown-menu rounded-2xl p-0.5 hrm_dropdown_menu_items">
            <slot name="menuItems">

            </slot>
        </div>
    </div>
</template>
<script setup lang="ts">
import { Icon } from "@iconify/vue";
import { ref } from "vue"


const showMenu = ref(false)

const props = defineProps(['icon'])
</script>
<style scoped>
.slide-fade-enter-active {
    transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateY(20px);
    opacity: 0;
}

.theme-dropdown-btn {
    border-radius: 6px !important;
    width: 26px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.hrm_table_menu .theme-dropdown-btn:hover {
    opacity: .6;
}

.dark .hrm_table_menu button.theme-dropdown-btn {
    background-color: #303337 !important;
}

.hrm_table_menu button.theme-dropdown-btn {
    background-color: #ebebeb !important;
}

.hrm_table_menu button.theme-dropdown-btn svg path {
    color: gray
}

@media (max-width: 768px) {


    .hrm_table_menu .theme-dropdown-btn:hover {
        opacity: 01;
    }

    .hrm_table_menu button.theme-dropdown-btn svg path {
        color: white !important;
    }

}

.dropdown-menu {
    padding: 0 !important;
}


.dark .hrm_table_menu .hrm_dropdown_menu_items {
    background-color: #24272a;

    border: 1px solid #373d42 !important;
    box-shadow: 1px 0px 9px 1px #0b0c0d;
}

.hrm_table_menu .hrm_dropdown_menu_items {
    background-color: #f8f8f8;

    border: 1px solid #dedede !important;
    box-shadow: 1px 0px 9px 1px #e1e1e1;
    border-radius: 4px;
}

.hrm_table_menu .hrm_dropdown_menu_items li.hrm_menu_item:not(.hrm_table_menu .hrm_dropdown_menu_items li.hrm_menu_item:last-child) {
    border-bottom: 1px solid #383d42;
}

.hrm_dropdown_menu_items {
    transition: .6s ease;
    animation: slideDown .6s forwards;
}

@keyframes slideDown {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.hrm_dropdown_menu_items ul li.hrm_menu_item .hrm_menu_item_inner {
    font-size: 12px;
    font-weight: 600;
    display: flex;
    padding: 4px 16px;
    color: #727b84;
}

.hrm_dropdown_menu_items ul li.hrm_menu_item:hover .hrm_menu_item_inner {
    color: var(--hrm_Theme_Text_Color);
    background-color: var(--hrm_Theme_Bg_Color);
}

.hrm_dropdown_menu_items ul li.hrm_menu_item {
    cursor: pointer;
}
</style>